import React from "react";
import { MdArrowBack, MdDelete, MdShoppingCart } from "react-icons/md";
import { formatRupiah, getProductImage } from "../../utils/ecommerce";

const CartPage = ({ cartItems, cartCount, cartTotal, backToHome, updateCartItem, deleteCartItem, goToCheckout }) => (
  <main className="page-container">
    <button className="back-link page-back" type="button" onClick={backToHome}>
      <MdArrowBack /> Lanjut Belanja
    </button>
    <section className="cart-panel">
      <div className="cart-title">
        <h1>Keranjang Belanja</h1>
        <span>{cartCount} produk</span>
      </div>
      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <MdShoppingCart />
          <h2>Keranjang masih kosong</h2>
          <p>Pilih produk elektronik favoritmu, lalu masukkan ke keranjang.</p>
          <button type="button" onClick={backToHome}>
            Mulai Belanja
          </button>
        </div>
      ) : (
        <>
          <div className="cart-list">
            {cartItems.map((item) => (
              <div className="cart-item" key={item.id}>
                <img src={getProductImage(item.barang)} alt={item.barang?.nama} />
                <div className="cart-item-info">
                  <h3>{item.barang?.nama}</h3>
                  <p>
                    {item.barang?.kategori?.nama || "Elektronik"} | {item.barang?.merk?.nama || "AJS"}
                  </p>
                  <b>{formatRupiah(item.harga)}</b>
                </div>
                <div className="cart-qty">
                  <button type="button" onClick={() => updateCartItem(item, Number(item.qty) - 1)}>
                    -
                  </button>
                  <span>{item.qty}</span>
                  <button type="button" onClick={() => updateCartItem(item, Number(item.qty) + 1)}>
                    +
                  </button>
                </div>
                <div className="cart-subtotal">
                  {formatRupiah(Number(item.qty || 0) * Number(item.harga || 0))}
                </div>
                <button className="cart-delete" type="button" onClick={() => deleteCartItem(item)}>
                  <MdDelete />
                </button>
              </div>
            ))}
          </div>
          <div className="cart-summary">
            <div>
              <span>Total Belanja</span>
              <b>{formatRupiah(cartTotal)}</b>
            </div>
            <button type="button" onClick={goToCheckout}>
              Checkout
            </button>
          </div>
        </>
      )}
    </section>
  </main>
);

export default CartPage;
